<template>
  <section class="footer-oversea">
    <div class="support-container">
      <div class="support-container-title">Support</div>
      <ul class="support-list">
        <li class="support-item">
          <a :href="faqUrl" target="_blank">{{ $t('footer-faq') }}</a>
        </li>
        <li class="support-item">
          <a :href="`https://www.oppo.com/${lang}/privacy/`" target="_blank">{{ $t('footer-user-privacy') }}</a>
        </li>
        <li class="support-item">
          <a :href="developerUrl" target="_blank">{{ $t('footer-developer') }}</a>
        </li>
      </ul>
    </div>
    <div class="contact-wrapper">
      <div class="contact-logo-list">
        <a href="http://bit.ly/ColorOS-TW" target="_blank" class="contact-logo-item"></a>
        <a href="http://bit.ly/ColorOS-INS" target="_blank" class="contact-logo-item"></a>
        <a v-if="!vm.config.youTubeUrl" href="http://bit.ly/ColorOS-FB" target="_blank" class="contact-logo-item"></a>
        <a v-else :href="vm.config.youTubeUrl" target="_blank" class="contact-logo-item youtube-logo"></a>
      </div>
      <div v-if="!vm.config.hideGlobal" class="global-wrapper">
        <span class="global-copyright">
          {{ $t('footer-copyright') }}
        </span>
        <a :href="`https://www.coloros.com/${lang}/global`" target="_blank">
          <img src="../assets/global.png" alt="ColorOS" class="global-logo" />
          <span>{{ $t('footer-global') }}</span>
        </a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  inject: {
    lang: { default: 'en' },
    vm: { default: { config: {} } }
  },
  computed: {
    faqUrl() {
      return this.vm.config.faqUrl || `https://support.oppo.com/${this.lang}/popular-topics/`;
    },
    developerUrl() {
      return this.vm.config.developerUrl || 'https://developers.oppomobile.com/';
    }
  }
};
</script>
<style lang="scss">
.footer-oversea {
  max-width: 1326px;
  border-top: 1px solid #e6e6e6;
  position: relative;
  padding-top: 60px;
  padding-bottom: 60px;
  font-size: 14px;
  overflow: hidden;
  margin: 0 auto;
  .support-container {
    float: left;
  }
  .support-container-title {
    font-variation-settings: 'wght' 750;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0.67px;
    margin-bottom: 15px;
    line-height: 23px;
    height: 23px;
  }
  .support-list {
    overflow: hidden;
  }
  .support-item a {
    font-size: 14px;
    color: #555555;
    line-height: 32px;
    cursor: pointer;
  }
  .support-item a:hover {
    opacity: 0.5;
    transition: all 0.3s ease;
  }
  .contact-logo-item {
    width: 40px;
    height: 40px;
    margin-left: 15px;
    display: inline-block;
    background-size: 40px 40px;
    &:nth-of-type(1) {
      background-image: url(../assets/footer/twitter.png);
    }
    &:hover:nth-of-type(1) {
      background-image: url(../assets/footer/twitter-hover.png);
    }
    &:nth-of-type(2) {
      background-image: url(../assets/footer/ins.png);
    }
    &:hover:nth-of-type(2) {
      background-image: url(../assets/footer/ins-hover.png);
    }
    &:nth-of-type(3) {
      background-image: url(../assets/footer/fb.png);
    }
    &:hover:nth-of-type(3) {
      background-image: url(../assets/footer/fb-hover.png);
    }
  }
  .contact-logo-item.youtube-logo {
    background-image: url(../assets/footer/youtube.png);
    &:hover {
      background-image: url(../assets/footer/youtube-dark.png);
    }
  }
}
.contact-wrapper {
  float: right;
  color: #bbb;
  .contact-logo-list {
    margin-bottom: 30px;
    text-align: right;
    font-size: 0;
  }
  .global-logo {
    position: relative;
    top: 0px;
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .global-copyright {
    margin-right: 18px;
  }
  a {
    color: #bbb;
  }
  a:hover {
    color: #000;
    transition: all 0.3s ease;
  }
}
@media screen and (max-width: 1440px) {
  .footer-oversea {
    margin-left: 4vw;
    margin-right: 4vw;
  }
}
@media screen and (max-width: 734px) {
  .footer-oversea {
    margin-left: 5vw;
    margin-right: 5vw;
    .support-container {
      float: unset;
      width: 100%;
    }

    .support-item {
      float: left;
      min-width: 50%;
    }
  }
  .contact-wrapper {
    float: unset;
    margin-top: 9.5vw;
  }
  .contact-wrapper .contact-logo-list {
    margin-bottom: 18px;
    text-align: left;
    .contact-logo-item:first-of-type {
      margin-left: 0;
    }
  }
  .global-wrapper a {
    display: block;
    padding-top: 18px;
    font-size: 0;
    span {
      vertical-align: bottom;
      font-size: 14px;
    }
  }
}
</style>
